import {Tooltip, Typography} from '@material-ui/core';
import React, {Fragment} from 'react';
import {DateService} from 'services/util/DateService';
import i18next from 'i18next';
import {TemplateStopType} from 'services/enums/TemplateStopType';
import {roundToFixed} from 'services/util/helperFuncs';

export function getUnassignedTemplateStopsGroupContent(
    unassignedTemplateStops
) {
    const t = i18next.t.bind(i18next);
    return (
        <Fragment>
            <Typography variant="body2">
                <strong>{t('notAssigned')}</strong>
            </Typography>
            <Typography variant="body2">
                <strong># {t('templateStops')}: </strong>
                {unassignedTemplateStops.length}
            </Typography>
            <Typography variant="body2">
                <strong># {t('shop')}: </strong>
                {
                    unassignedTemplateStops.filter(
                        (stop) => stop.stopType === TemplateStopType.Pickup
                    ).length
                }
            </Typography>
            <Typography variant="body2">
                <strong># {t('chest')}: </strong>
                {
                    unassignedTemplateStops.filter(
                        (stop) => stop.stopType === TemplateStopType.Delivery
                    ).length
                }
            </Typography>
        </Fragment>
    );
}

function getTemplateDeliveryWindow(template) {
    const templateStops = template.stops;
    const from =
        templateStops.length > 0 ? templateStops[0]?.deliveryWindow?.from : null;
    const to = templateStops[templateStops.length - 1]?.deliveryWindow?.to;
    return (
        <span style={{whiteSpace: 'nowrap'}}>
      {DateService.displayTime(from)} - {DateService.displayTime(to)}
    </span>
    );
}

export function getTemplateGroupContent(template) {
    const t = i18next.t.bind(i18next);
    return (
        <Fragment>
            <Typography variant="body2">
                <strong># {t('templateTemplateStops')}: </strong>
                {template.stops.length}
            </Typography>
            <Typography variant="body2">
                <strong># {t('shops')}: </strong>
                {
                    template.stops.filter(
                        (stop) => stop.stopType === TemplateStopType.Pickup
                    ).length
                }
            </Typography>
            <Typography variant="body2">
                <strong># {t('chests')}: </strong>
                {
                    template.stops.filter(
                        (stop) => stop.stopType === TemplateStopType.Delivery
                    ).length
                }
            </Typography>
            <Tooltip title={
                <div>
                    <strong>{t('driveTime')}:</strong> {roundToFixed(template.travelDurationInMin, 1)}
                    <br/>
                    <strong>{t('dwellTime')}:</strong> {roundToFixed(template.dwellTimeDurationInMin, 1)}
                </div>
            }>
                <Typography variant="body2">
                    <strong>{t('duration')}: </strong>{' '}
                    {roundToFixed(template.travelDurationInMin + template.dwellTimeDurationInMin, 1)}
                </Typography>
            </Tooltip>
            <Typography variant="body2">
                <strong>{t('length')}: </strong>
                {template.lengthKm}
            </Typography>
            <Typography variant="body2">
                <strong>{t('deliveryWindow')}: </strong>{' '}
                {getTemplateDeliveryWindow(template)}
            </Typography>
        </Fragment>
    );
}
